module.exports = __webpack_public_path__ + "static/media/stroke3.505a13af.png";